import React from 'react'
import PropTypes from 'prop-types'
import { BestOfferLink } from '../best-offer-link/best-offer-link'
import { ReservationStatusAction } from '../guest-actions/reservation-status-action'
import NotReservedAction from '../guest-actions/not-reserved-action'
import GiftCardOffer from '../gift-card-offer'
import RegItemCardLayout from '../reg-item-card-layout'
import AddOrBuy from 'registry/components/add-or-buy/add-or-buy'
import Card from 'components/card'

export const ReservableGiftCardRegItemCard = (
  { regItem, reservationByCurrentVisitor, openReservationModal },
  { registry }
) => {
  const { id, offers } = regItem

  const openReservationPanel = (children) => (
    <span onClick={openReservationModal}>{children}</span>
  )

  const regItemLink = (child) => {
    return openReservationPanel(
      <BestOfferLink offers={offers}>{child}</BestOfferLink>
    )
  }

  const actions = () => {
    return (
      <AddOrBuy
        reservation={reservationByCurrentVisitor}
        regItem={regItem}
        offers={offers}
        registry={registry}
      />
    )
  }

  return (
    <>
      <Card className="visible-xs">
        <RegItemCardLayout
          regItem={regItem}
          regItemLinkDecorator={regItemLink}
          actions={actions()}
        />
      </Card>
      <div className="hidden-xs">
        <RegItemCardLayout
          regItem={regItem}
          regItemLinkDecorator={regItemLink}
          actions={actions()}
        />
      </div>
    </>
  )
}

ReservableGiftCardRegItemCard.contextTypes = {
  registry: PropTypes.object,
}
